var map = {
	"./10_pourcent.png": "f793",
	"./20_pourcent.png": "6f52",
	"./30_pourcent.png": "34fe",
	"./40_pourcent.png": "0d4a",
	"./50_pourcent.png": "9bb9",
	"./60_pourcent.png": "1072",
	"./70_pourcent.png": "8db7",
	"./80_pourcent.png": "4c01",
	"./90_pourcent.png": "cdc3",
	"./Bientot.png": "b37f",
	"./En_ce_moment.png": "8ddc",
	"./Fabrique_en_France.png": "dd8e",
	"./Ici.png": "3423",
	"./Made_in_France.png": "8cc4",
	"./Nouveau.png": "5b90",
	"./Offre_Speciale.png": "b2bd",
	"./Offre_Speciale2.png": "4808",
	"./Origine.png": "a69f",
	"./Origine_Espagne.png": "acb5",
	"./Origine_France.png": "d2b8",
	"./Origine_France2.png": "5ed3",
	"./Origine_France_Officiel.png": "3ea3",
	"./Origine_France_Officiel2.png": "abf1",
	"./Origine_France_Officiel2_petit.png": "7eb5",
	"./Origine_UE.png": "614d",
	"./Peche_en_atlantique_nord_est.png": "1474",
	"./Prix_Choc.png": "06b6",
	"./Promo.png": "aef5",
	"./Promo_du_Jour.png": "e452",
	"./Promo_du_Jour2.png": "f0ce",
	"./Transforme_en_France.png": "365a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1660";